<template>
  <div class="h-screen overflow-hidden">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'BondHub',
};
</script>
